<template>
  <Grid ref="parentGrid" v-bind="{ ...props }" @add-button-clicked="addClick" @edit-button-clicked="editClick">
    <FluidAddEditForm ref="addEditRef" @submit-add-edit-form="onFormSubmit" :isEditMode="isEditMode" />
  </Grid>
</template>

<script>
import Constants from '../../constants/constants';
import FluidTypeConstants from '../../constants/fluid-types.constants';
import Grid from '../shared/Grid.vue';
import FluidAddEditForm from './FluidAddEditForm';
import FormMixin from '../shared/FormMixin';
import FluidClassConstants from '../../constants/fluid-class.constants';

export default {
  name: 'FluidGrid',
  data() {
    return {
      props: {
        api: { ...Constants.Api.Endpoint.Fluid },
        columns: Constants.Grid.Fluid.columns,
        doClientSide: Constants.Grid.Fluid.doClientSide,
        filter: Constants.Grid.Fluid.filter,
        paging: Constants.Grid.Fluid.paging,
        searchHeader: Constants.Grid.Fluid.searchHeader,
        searchPlaceholder: Constants.Grid.Fluid.searchPlaceholder,
        sort: Constants.Grid.Fluid.sort,
        title: Constants.Grid.Fluid.title
      },
      columnConstants: Constants.ColumnName.Fluid,
      idField: Constants.ColumnName.Fluid.fluidId.field,
      isEditMode: false
    };
  },
  mixins: [FormMixin],
  components: {
    Grid,
    FluidAddEditForm
  },
  methods: {
    addClick() {
      this.isEditMode = false;
      this.$refs.addEditRef.openDialog({
        fluidTypeID: FluidTypeConstants.OilId,
        fluidTypeName: FluidTypeConstants.Oil,
        fluidClass: FluidClassConstants.NA,
        fluidClassID: FluidClassConstants.NAId
      });
    },
    editClick(row) {
      this.isEditMode = true;
      this.$refs.addEditRef.openDialog({
        ...row,
        fluidClass: row.fluidClass ? row.fluidClass : FluidClassConstants.NA,
        fluidClassID: row.fluidClassID ? row.fluidClassID : FluidClassConstants.NAId,
        editMode: true
      });
    }
  }
};
</script>
